export const ROSE_IMAGES = {
  pink: "https://static.prod-images.emergentagent.com/jobs/92b64420-3ad3-46ab-b575-b1013f50b990/images/5e22998d5b28facb8ab5d0341e368d477159a38d907136c2077eeeff9e58cff6.jpeg",
  red: "https://static.prod-images.emergentagent.com/jobs/92b64420-3ad3-46ab-b575-b1013f50b990/images/c0ec7b806e64d2c110ec810d478683e42fb881d6000d112cc961d95cb8f073f3.jpeg",
  white: "https://static.prod-images.emergentagent.com/jobs/92b64420-3ad3-46ab-b575-b1013f50b990/images/e248b36f98d7a132b7dc79c28b25ea46ca8066eadfcd77ae6a4c8714956df510.jpeg",
  bouquet_two: "https://static.prod-images.emergentagent.com/jobs/92b64420-3ad3-46ab-b575-b1013f50b990/images/c37a518d079f14f517f4dcf2afc20df81609e5a90e3a8c8772ec2b924f200fb5.jpeg",
  bouquet_three: "https://static.prod-images.emergentagent.com/jobs/92b64420-3ad3-46ab-b575-b1013f50b990/images/47d68676300961a17ba0d094987d7ad5e2de0b4301d37e8cd0d6ef1bd6a64ccd.jpeg",
};

// Choose the backdrop image for a note based on attached roses
export function roseBackdrop(roses) {
  if (!roses || roses.length === 0) return null;
  if (roses.length === 1) return ROSE_IMAGES[roses[0]] || ROSE_IMAGES.pink;
  if (roses.length === 2) return ROSE_IMAGES.bouquet_two;
  return ROSE_IMAGES.bouquet_three;
}

export const ROSE_COLOR_HEX = {
  pink: "#F472B6",
  red: "#E11D48",
  white: "#F8FAFC",
};
